
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.503 2.92c-.235-.235-.573-.444-.968-.602a4.418 4.418 0 00-1.622-.308c-.781 0-1.488.201-2.041.498-.549.295-.96.694-1.128 1.103l-.011.027v7.63c0 .242.08.43.224.554.14.122.32.168.492.168.135 0 .248-.02.35-.06.101-.04.185-.095.264-.157h0l.006-.005c.284-.245.876-.59 1.844-.59.97 0 1.635.34 1.875.555h0l.006.006c.16.129.366.25.71.25.34 0 .542-.137.695-.244h0l.007-.005c.263-.21.916-.56 1.882-.56.968 0 1.565.349 1.844.589h0l.006.004c.08.062.163.117.264.157.102.04.215.06.35.06a.74.74 0 00.492-.168c.143-.124.224-.312.224-.554v-7.63l-.011-.027c-.168-.409-.58-.808-1.128-1.103a4.343 4.343 0 00-2.041-.498c-.591 0-1.153.12-1.622.308-.394.158-.73.367-.963.603zm-.59 1.036v6.578c-.537-.31-1.253-.477-2-.477-.75 0-1.467.166-2.004.49V3.96a.769.769 0 01.168-.211c.1-.095.237-.195.411-.287.347-.183.83-.33 1.425-.33.593 0 1.08.148 1.427.332.174.093.312.193.411.287.09.084.14.156.161.206zm5.011-.208c.09.084.143.157.168.21v6.59c-.537-.325-1.254-.49-2.004-.49-.747 0-1.464.165-2 .476V3.955a.699.699 0 01.162-.206c.099-.094.236-.194.41-.287a3.063 3.063 0 011.428-.331c.595 0 1.079.146 1.425.33.174.091.311.191.411.286z","fill":"#122546","stroke":"#122546","stroke-width":".3"}})])
          )
        }
      }
    